import React, { useState, useEffect } from 'react'
import { Loader } from 'semantic-ui-react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import './facedRating.scss'
export const FacedRating = ({
  mood = 'happy',
  onClick,
  isLoading,
  isSecond,
  state = '',
  ...props
}: {
  mood: 'happy' | 'unhappy'
  onClick: () => void
  isLoading: boolean
  state: string
  props?: any
}) => {
  return (
    <div className={isLoading ? 'FRB image loading' : 'FRB image'} onClick={onClick}>
      <div className={'image ' + mood + ' ' + state} />
      {(!isSecond || (isSecond && state !== '')) && (
        <div className='ui active inline tiny loader' />
      )}
    </div>
  )
}
